













































































import Vue from 'vue'
import _ from 'lodash'
// @ts-ignore
import { AgGridVue } from 'ag-grid-vue'
import { CompanyStructure, GridOptions } from '@/types'
import ColorCellRenderer from '@/components/cell-renderer/ColorCellRenderer.vue'
import {
  LOAD_COMPANY_STRUCTURE,
  LOAD_MASTER_DATA_FREE_SHIFT_LIST,
  INSERT_MASTER_DATA_FREE_SHIFT
} from '@/store/action-types'
import { CompanyStructureForPlanningResponse } from '@/types/service-response'
import { ProfitCenter } from '@/model/companyStructure/ProfitCenter'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import { Employee } from '@/model/companyStructure/Employee'
import { Department } from '@/model/companyStructure/Department'
import { MasterDataFreeShiftListPayload } from '@/types/payload'
import FreeShiftEditorDialog from '@/components/master-data/shifts/FreeShiftEditorDialog.vue'
import { MasterDataActionsEnum } from '@/types/enums'
import { FreeShift } from '@/model/master-data/FreeShift'
import DeleteDialog from '@/components/DeleteDialog.vue'
import { FreeShiftPlanningGroup } from '@/model/master-data/FreeShiftPlanningGroup'
import ActiveCellRenderer from '@/components/cell-renderer/ActiveCellRenderer.vue'
import { hexToRgba } from '@/services/hex-to-rgba'

interface ComponentData {
  gridData: Array<FreeShift>
  gridOptions: GridOptions
  gridFrameworkComponents: Object
  companyStructure: CompanyStructure
  profitCenterList: Array<ProfitCenter>
  selectedProfitCenterId: number | undefined
  selectedDepartmentId: number | undefined
  showEditorDialog: boolean
  showDeleteDialog: boolean
  currentSelectedRowId: string
  currentSelectedRowData: any | undefined
  action: MasterDataActionsEnum | undefined
  freeShiftData: Array<FreeShift> | undefined
  selectedFreeShift: FreeShift | undefined
  loading: boolean
  showErrorSnackbar: boolean
  editorDialogTitle: string
  overlayNoRowsTemplate: string
  showAllShifts: boolean
  showSearchField: boolean
  search: string | null
}

export default Vue.extend({
  name: 'FreeShiftsConfigurator',

  components: {
    AgGridVue,
    FreeShiftEditorDialog,
    DeleteDialog
  },

  data (): ComponentData {
    return {
      companyStructure: {
        profitCenterList: [],
        departmentList: [],
        planningGroupList: [],
        employeeList: []
      },

      gridData: [],
      gridOptions: {
        columnDefs: [
          { headerName: this.$t('masterData.shifts.code'), field: 'code' },
          { headerName: this.$t('masterData.shifts.description'), field: 'description' },
          { headerName: this.$t('masterData.shifts.start'), field: 'start' },
          { headerName: this.$t('masterData.shifts.end'), field: 'end' },
          {
            headerName: this.$t('masterData.shifts.numberOfEmployees'),
            valueGetter: function (params: any) {
              let result: number = 0
              params.data.planningGroupData.forEach((item: FreeShiftPlanningGroup) => {
                result += item.numberOfEmployees
              })
              return result
            }
          },
          { headerName: this.$t('color'), field: 'color', cellRenderer: 'colorRenderer' },
          { headerName: this.$t('masterData.shifts.active'), field: 'isActive', cellRenderer: 'activeRenderer' }
        ]
      },

      gridFrameworkComponents: {
        colorRenderer: ColorCellRenderer,
        activeRenderer: ActiveCellRenderer
      },

      profitCenterList: [],
      selectedProfitCenterId: undefined,
      selectedDepartmentId: undefined,
      showEditorDialog: false,
      showDeleteDialog: false,
      currentSelectedRowId: '',
      currentSelectedRowData: undefined,
      action: undefined,
      freeShiftData: undefined,
      selectedFreeShift: undefined,
      loading: false,
      showErrorSnackbar: false,
      editorDialogTitle: '',
      overlayNoRowsTemplate: '<span>' + this.$t('errors.noRowsToShow') + '</span>',
      showAllShifts: false,
      showSearchField: false,
      search: null
    }
  },

  computed: {
    isAddButtonEnabled (): boolean {
      return !!(this.selectedProfitCenterId && this.selectedDepartmentId)
    },

    isEnableButtons (): boolean {
      return !!(this.currentSelectedRowId)
    },

    isShowButtonEnabled (): boolean {
      return !!(this.selectedProfitCenterId && this.selectedDepartmentId)
    },

    setShowButtonIcon (): string {
      if(this.showAllShifts) {
        return 'visibility'
      } else {
        return 'visibility_off'
      }
    },

    departmentList (): Array<Department> {
      let list: Array<Department> = []

      if (this.selectedProfitCenterId) {
        list = this.companyStructure.departmentList
          .filter((item: Department) => item.profitCenterId === this.selectedProfitCenterId)
      }

      return list
    },

    planningGroupList (): Array<PlanningGroup> {
      let list: Array<PlanningGroup> = []

      if (this.selectedProfitCenterId && this.selectedDepartmentId) {
        list = this.companyStructure.planningGroupList
          .filter((item: PlanningGroup) => item.department === this.selectedDepartmentId)
      }

      return list
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    },

    isSearchEnabled (): boolean {
      return this.gridData.length > 0
    },

    filteredGridData (): FreeShift[] {
      if(this.search) {
        return this.gridData.filter((item: FreeShift) => {
          return item.description.toLowerCase().includes(this.search!.toLowerCase())
        })
      } else {
        return this.gridData
      }
    }
  },

  methods: {
    onProfitCenterValueChange (): void {
      this.selectedDepartmentId = undefined
      if(this.departmentList.length > 0) {
        this.selectedDepartmentId = this.departmentList[0].id
      }
      this.onDepartmentValueChange()
      this.gridData = []
      this.currentSelectedRowId = ''
      this.currentSelectedRowData = undefined
      this.selectedFreeShift = undefined
    },

    onDepartmentValueChange (): void {
      if (this.selectedDepartmentId) {
        this.currentSelectedRowId = ''
        this.currentSelectedRowData = undefined
        this.selectedFreeShift = undefined
        this.fetchFreeShiftList()
      }
    },

    onAddButtonClick (): void {
      this.currentSelectedRowData = undefined
      this.editorDialogTitle = this.$t('masterData.shifts.addNewFreeShiftDialogTitle').toString()
      this.showEditorDialog = true
      this.action = MasterDataActionsEnum.Create
    },

    onEditButtonClick (): void {
      this.currentSelectedRowData = this.gridData.find((item: any) => item.id === parseInt(this.currentSelectedRowId))
      this.editorDialogTitle = this.$t('masterData.shifts.editFreeShiftDialogTitle').toString()
      this.showEditorDialog = true
      this.action = MasterDataActionsEnum.Update
    },

    onDeleteButtonClick (): void {
      this.showDeleteDialog = true
      this.action = MasterDataActionsEnum.Delete
    },

    onDeleteDialogSave (): void {
      this.currentSelectedRowData = this.gridData.find((item: any) => item.id === parseInt(this.currentSelectedRowId))
      this.onEditorDialogSave(this.currentSelectedRowData)
      this.showDeleteDialog = false
    },

    onEditorDialogClose (): void {
      this.showEditorDialog = false
      this.action = undefined
    },

    onDeleteDialogClose (): void {
      this.showDeleteDialog = false
      this.action = undefined
    },

    async onEditorDialogSave (formData: FreeShift): Promise<void> {

      const payload: any = {
        action: this.action,
        freeShift: formData
      }
      try {
        this.loading = true
        await this.$store.dispatch(INSERT_MASTER_DATA_FREE_SHIFT, payload)
        this.loading = false
        this.showEditorDialog = false
        this.action = undefined
        this.currentSelectedRowId = ''
        this.currentSelectedRowData = undefined
        this.fetchFreeShiftList()
      } catch (e) {
        this.loading = false
        this.showErrorSnackbar = true
      }
    },

    async fetchFreeShiftList (): Promise<void> {
      const payload: MasterDataFreeShiftListPayload = {
        departmentId: this.selectedDepartmentId!
      }

      const data = await this.$store.dispatch(LOAD_MASTER_DATA_FREE_SHIFT_LIST, payload)
      this.freeShiftData = data
      if (this.freeShiftData) {
        if(this.showAllShifts) {
          this.gridData = _.cloneDeep(this.freeShiftData)
        } else {
          this.gridData = this.freeShiftData.filter((item: FreeShift) => item.isActive === true)
        }
      }
    },

    onRowClicked (params: any): void {
      this.currentSelectedRowId = params.node.data.id
    },

    onShowUnactiveShifts (): void {
      this.currentSelectedRowId = ''
      this.currentSelectedRowData = undefined
      this.showAllShifts = !this.showAllShifts

      if(this.showAllShifts && this.freeShiftData) {
        this.gridData = _.cloneDeep(this.freeShiftData)
      } else {
        this.gridData = this.freeShiftData!.filter((item: FreeShift) => item.isActive === true)
      }
    },

    onSearchButtonClick (): void {
      this.showSearchField = !this.showSearchField
      if(!this.showSearchField) {
        this.search = null
      }
    }
  },

  async mounted () {
    const responseData: CompanyStructureForPlanningResponse = await this.$store.dispatch(LOAD_COMPANY_STRUCTURE)

    this.companyStructure = {
      profitCenterList: ProfitCenter.createFromResponse(responseData),
      departmentList: Department.createFromResponse(responseData),
      planningGroupList: PlanningGroup.createFromResponse(responseData),
      employeeList: Employee.createFromResponse(responseData)
    }

    this.profitCenterList = this.companyStructure.profitCenterList

    const userId = this.$store.state.currentUser.id
    const user: Employee | undefined = this.companyStructure.employeeList.find((item: Employee) => userId === item.id)
    if (user && this.profitCenterList) {
      const foundProfitCenter: ProfitCenter | undefined = this.profitCenterList.find((item: ProfitCenter) => user.profitCenter === item.id)
      this.selectedProfitCenterId = foundProfitCenter ? foundProfitCenter.id : undefined
      this.onProfitCenterValueChange()
    }

    if (user && this.departmentList) {
      const foundDepartment: Department | undefined = this.departmentList.find((item: Department) => user.department === item.id)
      this.selectedDepartmentId = foundDepartment ? foundDepartment.id : undefined
      this.onDepartmentValueChange()
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 0)
  }
})
